import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as yup from 'yup';
import { Formik } from 'formik';
import Dialog from '@mui/material/Dialog';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Dropzone from 'react-dropzone';
import { closePopup } from '../../actions/uiActions';
import { dbupload } from '../../actions/userActions';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import CloseIcon from '@mui/icons-material/Close';
import { DatabaseIcon } from '../../images/js/databaseIcon';

class DBupload extends React.Component {
    state = {
        fileName: "",
        file: null,
        customerDatabaseID: null
    }

    SQLDBList = [];
    constructor(props) {
        super(props);
        // get SQL servers
        this.SQLDBList = this.props.dbList.filter(x => x.serverType == 0);
    }

    componentDidMount() {
        // put database in state in case user is sticking with default selection
        if (this.SQLDBList.length > 0)
        {
            this.setState({ customerDatabaseID: this.SQLDBList[0].id})
        }
    }

    handleSubmit = (event) => {
        if (event.preventDefault !== undefined) { event.preventDefault(); }
        const data = new FormData();

        if (this.state.fileName.length > 0) {
            data.append('file', this.state.file, this.state.fileName);
        } else {
            data.append('file', this.state.file);
        }
        data.append('customerDatabaseID', this.state.customerDatabaseID)
 
        this.props.dbupload(data);
    }

    changeName = (event) => {
        this.setState({ fileName: event.target.value })
    }

    fileChangedHandler = (event) => {
        this.setState({ file: event.target.files[0] })
    }

    handleClick = (event) => {
        event.preventDefault();
        this.props.closePopup();
    }

    onDrop(file, values) {
        if (file.length > 0) {
            let uploadedFileName = file[0]["name"]
            //let fileName = SeparateFileNameAndExtension(uploadedFileName)["name"]
            //let currentFileName = (this.state.fileName !== "") ? this.state.fileName : uploadedFileName

            values["name"] = uploadedFileName
            
            this.setState({
                file: file[0],
                fileName: uploadedFileName,
            });

        }
    }

  
    renderDropTitle() {
        return (this.state.file !== null) ? (<h5>Current File: {this.state.fileName}</h5>) : (<h5>Drop or Click Here to Upload File</h5>)
    }

    handleDatabase = (event) => {
        event.preventDefault()
        this.setState({ customerDatabaseID: event.target.value })
    }

    populateDatabases = () => {
        if (this.SQLDBList) {
                return (
                    <Select
                        className="myInput"
                        onChange={this.handleDatabase}
                        //value={this.state.customerDatabaseID !== "" ? this.state.customerDatabaseID : this.SQLDBList.length > 0 ? this.SQLDBList[0].dBname : ''}
                        defaultValue={this.SQLDBList.length > 0 ? this.SQLDBList[0].id : ''}
                        displayEmpty
                        required
                        inputProps={{ 'aria-label': 'Without label' }}
                    >
                        <MenuItem value="" disabled hidden>Select Database</MenuItem>

                        { this.SQLDBList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}

                    </Select>
                )
            } else {
                return (<div />)
            }        
    }

    render() {
        return (<Dialog
            open={true}
            onClose={this.handleClick}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >      <CloseIcon onClick={this.handleClick} className="closePoup" />
            <DialogTitle id="alert-dialog-title" className="changepassdialog">XP3 database only (XDB)</DialogTitle>
                <DialogContent id="alert-dialog-description">             
                    <Formik
                        initialValues={{
                            name: '',
                        }}
                        onSubmit={this.handleSubmit}
                        validationSchema={yup.object().shape({ name: yup.string().required('Required') })}
                    >
                        {({
                            values,
                            handleChange,
                            errors,
                            setFieldTouched,
                            touched,
                            handleSubmit
                        }) => (
                            <form>
                                <div className="passwordResetbox">
                                    <div className="uploadOut">
                                    <Dropzone onDrop={(file) => {
                                        this.onDrop(file, values)
                                    }}>
                                        {({getRootProps, getInputProps}) => (
                                            (this.state.file !== null) ? 
                                            (<div id="dropzone" {...getRootProps()}>
                                                <h5>Current File: {this.state.file.name}</h5>
                                                <input {...getInputProps()} />
                                            </div>) : 
                                            (<div id="dropzone" {...getRootProps()}>
                                                <h5>Drop or Click Here to Upload File</h5>
                                                <input {...getInputProps()} />
                                            </div>)
                                        )}
                                    </Dropzone>
                                    <AddPhotoAlternateIcon />
                                </div>
                                <div className="myInputOut">
                                    <DatabaseIcon style={{ display: "block", float: "left", paddingTop: "10px" }} /> <div style={{ float: "right", width: "90%" }}> {this.populateDatabases()} </div>
                                </div>
                                <br /><br /><div>&nbsp;</div>
                                <label className="redLabel">Selected Database Will Be Overwritten</label>
                                <br></br>
                                     
                                    <div>
                                        <button type="submit" className="btn" onClick={(e) => handleSubmit(e)}>Submit</button>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Formik>
                </DialogContent>
        </Dialog>
        )
    }
}

function mapStateToProps(state) {
    return {     
        customerID: state.users.customerID,
        dbList: state.users.custDBList,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ closePopup, dbupload }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DBupload)